import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flex _jc-fe" }
const _hoisted_2 = { class: "gfu-project-summary-details-list" }
const _hoisted_3 = { class: "gfu-project-summary-details-list__item _py-1 _mb-2" }
const _hoisted_4 = { class: "gfu-hd gfu-hd--h3 _flex _mb-1 _ai-c" }
const _hoisted_5 = { class: "gfu-bt gfu-bt--b2" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "gfu-project-summary-details-list__item _py-1 _mb-2" }
const _hoisted_8 = { class: "gfu-hd gfu-hd--h3 _flex _mb-1" }
const _hoisted_9 = { class: "gfu-bt gfu-bt--b2" }
const _hoisted_10 = { class: "gfu-project-summary-details-list__item _py-1 _mb-2" }
const _hoisted_11 = { class: "gfu-hd gfu-hd--h3 _flex _mb-1" }
const _hoisted_12 = { class: "gfu-bt gfu-bt--b2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "gfu-project-summary-details-list__item _py-2" }
const _hoisted_15 = { class: "gfu-hd gfu-hd--h3 _flex _mb-1" }
const _hoisted_16 = { class: "gfu-bt gfu-bt--b2" }
const _hoisted_17 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_localize = _resolveComponent("localize")
  const _component_project_summary_box = _resolveComponent("project-summary-box")

  return (_openBlock(), _createBlock(_component_project_summary_box, { borderless: true }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "_tc--accent _flexinline _ai-c _pa-0",
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.close && $options.close(...args)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Common.ModalCloseButton), 1 /* TEXT */),
          _createVNode(_component_base_icon, {
            name: "times",
            size: "lg",
            class: "_ml-1"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_base_icon, {
              name: "brand-outline",
              "icon-namespace": "ga",
              size: "lg",
              class: "_mr-1 _tc--accent"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMoreAboutCrowdfundingHeader), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMoreAboutCrowdfundingText) + " ", 1 /* TEXT */),
            _createElementVNode("a", {
              href: $props.crowdfundingGuideUrl,
              class: "gfu-link gfu-link--nofx gfu-link--accent"
            }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMoreAboutCrowdfundingReadMoreLinkW), 9 /* TEXT, PROPS */, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_base_icon, {
              name: "bullseye-arrow",
              class: "_tc--accent _mr-1"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMoreFundingModeHeader), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString($options.projectSummaryLearnMoreFundingModeText), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_base_icon, {
              name: "clock",
              class: "_tc--accent _mr-1"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMoreEndDateHeader), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createTextVNode(_toDisplayString($options.campaignEndScheduledAt) + " ", 1 /* TEXT */),
            ($options.isCrowdfundingOvertimeActive)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _cache[1] || (_cache[1] = _createTextVNode(" + Endgame ", -1 /* CACHED */)),
                  _createVNode(_component_tooltip, {
                    "icon-name": "circle-info",
                    text: $options.overtimeTooltipText
                  }, null, 8 /* PROPS */, ["text"])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_base_icon, {
              name: "dice",
              class: "_tc--accent _mr-1"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMorePossibleRisksHeader), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.ProjectHome.ProjectSummaryLearnMorePossibleRisksText
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  "format-key": "0",
                  href: $props.risksUrl,
                  class: "gfu-link gfu-link--nofx gfu-link--accent"
                }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMorePossibleRisksLink), 9 /* TEXT, PROPS */, _hoisted_17)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}